import React, {Component} from 'react';
import {Row, Col, InputGroup, Progress, FormText, CardTitle, Card, CardHeader, Alert, CardBody, FormGroup, Label, Form, Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet } from '../../utils/deviceAPI';
import LoadingIndicator from '../../utils/LoadingIndicator';
import Siteslist from '../../components/Sitelist/Siteslist';
import Pendingnotifications from '../../components/Sitelist/Pendingnotifications';
import Preferredsite from '../../components/Sitelist/Preferredsite';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import NotificationHOC from "../../components/Notifications/NotificationHOC";

const defaultChangePassword = {
    changepasswordCurrent: "",
    changepasswordNew: "",
    changepasswordNewRepeat: "",
    changepasswordCurrentValid: false,
    changepasswordNewValid: false,
    changepasswordNewRepeatValid: false,
    changepasswordFormValid: false,
    formMessage: {
        changepasswordCurrent : "",
        changepasswordNew : "",
        changepasswordNewRepeat : "",
        fromServer: ""
    },
    phoneValid: false,
    newPhoneNumber: "",
    phoneVerification: false,
    phoneVerificationServerMessage: "",
    phoneVerificationServerMessageError: false,
    pinNumber: 0,
    isPinVerifyValid: false,
    pinVerification: false,
    isPinVerifyValidServerMessageError: ""

};

const Loginhistory = (props) => {
    const listItems = props.loginhistory.map((information,index) => {
            return (
                <li key={index} className="mb-3 mt-3 listSiteItems">
                    <i className={"fa fa-key"}></i>
                    <div className="desc">
                        <div className="title">{information.ip}</div>
                        <div className="small text-muted text-lowercase pb-3">{information.time}</div>
                    </div>
                    <div className="value mr-4">
                        <div className="small text-muted">Agent</div>
                        <div className="small text-danger">{information.agent.substring(0,8)}</div>
                    </div>
                    <div className="actions">
                        <Button color="link" className="text-muted"><i className="fa fa-dot-circle-o"></i></Button>
                    </div>
                </li>
            );
        }
    );
    return (
        <ul className="icons-list mb-5 list-inline">
            {listItems}
        </ul>
    )
};

class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
            {
                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            loading: true,
            accountInformation:[],
            changepasswordCurrent: "",
            changepasswordNew: "",
            changepasswordNewRepeat: "",
            changepasswordCurrentValid: false,
            changepasswordNewValid: false,
            changepasswordNewRepeatValid: false,
            changepasswordFormValid: false,
            formMessage: {
                changepasswordCurrent : "",
                changepasswordNew : "",
                changepasswordNewRepeat : "",
                fromServer: ""
            },
            newNotification: false,
            changeTelephoneModal: false,
            phoneValid: false,
            newPhoneNumber: "",
            phoneVerification: false,
            phoneVerificationServerMessage: "",
            phoneVerificationServerMessageError: false,
            pinNumber: 0,
            pinVerification: false,
            isPinVerifyValidServerMessageError: "",
            isPinVerifyValid: false,



        };
        this.toggle = this.toggle.bind(this);
        this.toggleChangePhone = this.toggleChangePhone.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.changeRequestPhone = this.changeRequestPhone.bind(this);
        this.changeRequestVerify = this.changeRequestVerify.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.formDefaults = this.formDefaults.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    componentWillUnmount(){

    }
    newNotification = (data) => {
        if (!this.state.newNotification && data >= 1) {
            this.setState({ newNotification: true });
        }
    };
    setData() {
        ajaxWrapperGet('/api/user/account').then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
    toggleChangePhone() {
        this.setState({
            changeTelephoneModal: !this.state.changeTelephoneModal
        });
    }
    prefferedSiteSet(device) {
        let postData = {
            dev: device
        };
        ajaxWrapperPost(`/api/account/preferredSite`,postData).then((data) => {
            if (!data.error) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
            }
            else if (data.error) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
            [name]: value
        },
            () => { this.validateField(name, value) }

        );
    }
    validateField(fieldName, value) {
        let oldPasswordValid = this.state.changepasswordCurrentValid;
        let newPasswordValid = this.state.changepasswordNewValid;
        let newPasswordValidRepeat = this.state.changepasswordNewRepeatValid;
        let formMessagechangepasswordCurrent = this.state.formMessage.changepasswordCurrent;
        let formMessagechangepasswordNew = this.state.formMessage.changepasswordNew;
        let formMessagechangepasswordNewRepeat = this.state.formMessage.changepasswordNewRepeat;
        let telValid = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        let internalPhoneValid = this.state.phoneValid;
        switch(fieldName) {
            case 'newPhoneNumber':
                internalPhoneValid = telValid.test(value);
                break;
            case 'changepasswordCurrent':
                if (value.length < 3) {
                    oldPasswordValid = false;
                    formMessagechangepasswordCurrent = "Password must be 3 characters or greater !";
                }
                else {
                    oldPasswordValid = true;
                    formMessagechangepasswordCurrent = "";

                }
                break;
            case 'changepasswordNew':
                if (value.length < 8) {
                    newPasswordValid = false;
                    formMessagechangepasswordNew = "Password must be 8 characters or greater !";
                }
                else if ((value.search(/[a-z]/i) < 0) || (value.search(/[0-9]/) < 0) || (value.search(/[A-Z]/i) < 0)) {
                    newPasswordValid = false;
                    formMessagechangepasswordNew = "Password must contain at least one number, one uppercase character and one lowercase character!";
                }
                else {
                    newPasswordValid = true;
                    formMessagechangepasswordNew = "";

                }
                break;
            case 'changepasswordNewRepeat':
                if (value !== this.state.changepasswordNew ) {
                    newPasswordValidRepeat = false;
                    formMessagechangepasswordNewRepeat = "Password Confirmation does not match ! ";
                }
                else {
                    newPasswordValidRepeat = true;
                    formMessagechangepasswordNewRepeat = "";

                }
                break;

        }

        this.setState({
            phoneValid : internalPhoneValid,
            changepasswordCurrentValid : oldPasswordValid,
            changepasswordNewValid : newPasswordValid,
            changepasswordNewRepeatValid : newPasswordValidRepeat,
            changepasswordFormValid: oldPasswordValid && newPasswordValid && newPasswordValidRepeat,
            formMessage: {
                changepasswordCurrent : formMessagechangepasswordCurrent,
                changepasswordNew : formMessagechangepasswordNew,
                changepasswordNewRepeat : formMessagechangepasswordNewRepeat,
                fromServer: ""
            }
        });

    }
    changePassword() {
        let postData = {
            changepasswordCurrent: this.state.changepasswordCurrent,
            changepasswordNew: this.state.changepasswordNew,
            changepasswordNewRepeat: this.state.changepasswordNewRepeat
        };

        ajaxWrapperPost('/api/user/changepassword',postData).then((data) => {
            if (data.error) {
                this.setState({
                    formMessage: {
                        changepasswordCurrent : "",
                        changepasswordNew : "",
                        changepasswordNewRepeat : "",
                        fromServer: data.message
                    }
                });

            }
            else {
                this.toggle();
                this.formDefaults();
            }

        });

    }
    changeRequestPhone() {
        let postData = {
            newPhoneNumber: this.state.newPhoneNumber
        };

        ajaxWrapperPost('/api/user/changeTelephoneVerify',postData).then((data) => {
            this.setState({
                phoneVerification:true,
                phoneVerificationServerMessage: data.message,
                phoneVerificationServerMessageError: data.error
            });
        });

    }
    changeRequestVerify() {
        let postData = {
            pin: this.state.pinNumber
        };

        ajaxWrapperPost('/api/user/changeTelephoneVerifyPin',postData).then((data) => {
            this.setState({
                pinVerification: true,
                isPinVerifyValidServerMessageError: data.message,
                isPinVerifyValid: !data.error
            });
        });

    }

    formDefaults() {
        this.setState(defaultChangePassword);
    }
    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const { data } = this.state;
        const loginHistory = JSON.parse(data.accountInformation.loginHistory);
        const { alarms } = this.props.uidata;
        return (
            <div className="containerAnimation">
            <div className="fadeInUp">
                <NotificationHOC ref="notification"/>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Change Password</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col xs="12">
                                    <FormGroup>
                                        <Label htmlFor="addNewUserpassword">Current Password</Label>
                                        <Input type="password" id="changepasswordCurrent" name="changepasswordCurrent" className={this.state.changepasswordCurrentValid ? "is-valid" : "is-invalid"} placeholder="" value={ this.state.changepasswordCurrent } onChange={ this.handleChange } required/>
                                        {this.state.formMessage.changepasswordCurrent.length <= 0 ? "" :
                                            <div className="invalid-feedback" id="passwordError" >{this.state.formMessage.changepasswordCurrent}</div>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <FormGroup>
                                        <Label htmlFor="changepasswordNew">New Password</Label>
                                        <Input type="password" id="changepasswordNew" name="changepasswordNew" className={this.state.changepasswordNewValid ? "is-valid" : "is-invalid"} placeholder="" value={ this.state.changepasswordNew } onChange={ this.handleChange } required/>
                                        <div className="error" id="passwordError" />
                                        {this.state.formMessage.changepasswordNew.length <= 0 ? "" :
                                            <div className="invalid-feedback" id="passwordError" >{this.state.formMessage.changepasswordNew}</div>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <FormGroup>
                                        <Label htmlFor="changepasswordNewRepeat">Retype New Password </Label>
                                        <Input type="password" id="changepasswordNewRepeat" name="changepasswordNewRepeat" className={this.state.changepasswordNewRepeatValid ? "is-valid" : "is-invalid"} placeholder="" value={ this.state.changepasswordNewRepeat } onChange={ this.handleChange } required/>
                                        <div className="error" id="passwordError" />
                                        {this.state.formMessage.changepasswordNewRepeat.length <= 0 ? "" :
                                            <div className="invalid-feedback" id="passwordError" >{this.state.formMessage.changepasswordNewRepeat}</div>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            {this.state.formMessage.fromServer.length <= 0 ? "" :
                                <Row>
                                    <Col xs="12">
                                        <FormGroup>
                                            <div className="text-danger" id="responseFromServer" >{this.state.formMessage.fromServer}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.changePassword} disabled={!this.state.changepasswordFormValid}>Change Password</Button>{' '}
                        <Button color="secondary" onClick={(event) => { this.toggle(); this.formDefaults();}}>Cancel</Button>

                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.changeTelephoneModal} toggle={this.toggleChangePhone} className={this.props.className}>
                    <ModalHeader>Change Telephone</ModalHeader>
                    <ModalBody>
                        {!this.state.phoneVerification ?
                            <Row>
                                <Col sm="12">
                                    <Label>New Phone Number</Label>
                                    <InputGroup>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="fa fa-phone"></i></span>
                                        </div>
                                        <TextMask
                                            mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            Component={InputAdapter}
                                            className={this.state.phoneValid ? "form-control is-valid" : this.state.newPhoneNumber === "" ? "form-control" : "form-control is-invalid"}
                                            id="newPhoneNumber"
                                            name="newPhoneNumber"
                                            onChange={this.handleChange}
                                            value={this.state.newPhoneNumber}
                                        />
                                    </InputGroup>
                                    <FormText color="muted">
                                        ex. (999) 999-9999
                                    </FormText>
                                    <FormText color="danger" className="pt-3">
                                        Note: Please make sure you have access to this phone, as confirmation is
                                        required to change your number.
                                    </FormText>
                                </Col>
                            </Row>
                            : this.state.phoneVerificationServerMessageError ?
                                <Row>
                                    <Col sm="12">
                                        <Alert color="danger">
                                            {this.state.phoneVerificationServerMessage}
                                        </Alert>
                                    </Col>
                                </Row>
                                : this.state.isPinVerifyValidServerMessageError === "Phone Number Successfully Changed" ?
                                    <Row>
                                        <Col sm="12">
                                            <Alert color="success">
                                                {this.state.isPinVerifyValidServerMessageError}
                                            </Alert>
                                        </Col>
                                    </Row>
                                    :
                                <Row>
                                    <Col sm="12">
                                        <Label>Verify your pin</Label>
                                        <InputGroup className="mb-3">
                                            <div className="input-group-prepend"><span className="input-group-text">PIN</span></div>
                                            <Input type="text" placeholder="pinNumber" id="pinNumber" name="pinNumber" className={this.state.isPinVerifyValid ? "is-valid" : "is-invalid"} value={ this.state.pinNumber } onChange={ this.handleChange } required/>
                                            <div className="invalid-feedback" id="isPinVerifyValidServerMessageError" >{this.state.isPinVerifyValidServerMessageError}</div>

                                        </InputGroup>
                                    </Col>
                                </Row>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Col sm="6" className="small text-muted">
                            <Button color="secondary" className="btn btn-block" onClick={(event) => { this.toggleChangePhone(); this.formDefaults();}}>Cancel</Button>
                        </Col>
                        <Col sm="6" className="small text-muted">
                            {this.state.phoneVerification ? this.state.isPinVerifyValidServerMessageError === "Phone Number Successfully Changed" ?
                                <Button color="success" className="btn btn-block" onClick={(event) => { this.toggleChangePhone(); this.formDefaults(); this.setData();}}>Close</Button>
                                :
                                <Button color="success" className="btn btn-block" onClick={this.changeRequestVerify}
                                        disabled={this.state.pinNumber === 0}>Verify Pin</Button>
                                :
                                <Button color="success" className="btn btn-block" onClick={this.changeRequestPhone}
                                        disabled={!this.state.phoneValid}>Request Change</Button>
                            }
                        </Col>
                    </ModalFooter>
                </Modal>
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="10">
                                        <CardTitle className="mb-1">Pending Site Invites</CardTitle>
                                        <div className="small text-muted">view and accept pending site information</div>
                                    </Col>
                                    <Col sm="2" className="d-none d-sm-inline-block">
                                        <i className="fa fa-hourglass-end float-right text-secondary"></i>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <Pendingnotifications checkForNewNotifications={this.newNotification}/>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" sm="12" md="6" xl="6">
                        <Row>
                            <Col xs="12">
                                <Card>
                                    <CardBody className="card-body">
                                        <Row className="pb-4">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Account Information</CardTitle>
                                                <div className="small text-muted">view or change account information</div>
                                            </Col>
                                            <Col sm="2" className="d-none d-sm-inline-block">
                                                <i className="fa fa-user float-right text-secondary"></i>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                                <div className="text-primary text-uppercase font-weight-bold font-sm">{data.accountInformation.firstname} {data.accountInformation.lastname}</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                                <div className="text-muted text-lowercase font-sm">{data.accountInformation.email}</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                                <div className="text-muted text-lowercase font-sm">{data.accountInformation.tel}</div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" sm="12" lg="6" xl="6" className="mt-4">
                                                <Button onClick={this.toggle} color="primary" className="btn btn-block btn-outline-secondary">Change Password</Button>
                                            </Col>
                                            <Col xs="12" sm="12" lg="6" xl="6" className="mt-4">
                                                <Button onClick={this.toggleChangePhone} color="primary" className="btn btn-block btn-outline-secondary">Change Telephone</Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Preferredsite sites={this.props.uidata.alarms} preferredSite={this.props.preferredSite} prefferedSiteSet={(device) => this.prefferedSiteSet(device)}/>
                        </Row>
                        <Row>
                            <Col xs="12">
                                <Card>
                                    <CardBody className="card-body">
                                        <Row className="pb-4">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Current Sites</CardTitle>
                                                <div className="small text-muted">current list of sites you have permission to access</div>
                                            </Col>
                                            <Col sm="2" className="d-none d-sm-inline-block">
                                                <i className="fa fa-list float-right text-secondary"></i>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                                {alarms !== undefined ? <Siteslist sites={this.props.uidata.alarms} goToSite={(siteUrl) => this.props.goToSite(siteUrl)}/> : ""}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" sm="12" md="6" xl="6">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="10">
                                        <CardTitle className="mb-1">Login History</CardTitle>
                                        <div className="small text-muted">Please review your account activity for any unknown logons. If you suspect that you had an unauthorized login, please change your password and contact your account administrator.</div>
                                    </Col>
                                    <Col sm="2" className="d-none d-sm-inline-block">
                                        <i className="fa fa-history float-right text-secondary"></i>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                        <Loginhistory loginhistory={loginHistory}/>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </div>
            </div>
        )
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account/Account.js